// extracted by mini-css-extract-plugin
export var footer = "_bg-0";
export var inherit = "_bg-1";
export var input = "_bg-2";
export var modalContent = "_bg-3";
export var quillEditor = "_bg-4";
export var subtitle = "_bg-5";